<template>
  <el-dialog
    class="customDialogForm"
    width="600px"
    title="直接交付"
    :visible.sync="dialogVisible"
    :before-close="handleClose"
  >
    <el-form
      autocomplete="on"
      style="padding: 0 90px"
      ref="Forms"
      label-position="left"
      :rules="rules"
      :model="deliveryForm"
      @submit.native.prevent
    >
      <el-form-item
        prop="customer"
        label="客户名称"
        :label-width="formLabelWidth"
      >
        <el-select
          v-model="deliveryForm.customer"
          filterable
          placeholder="请选择"
          @change="this.changeCustomer"
        >
          <el-option
            v-for="item in customerList"
            :key="item.customerID"
            :label="item.customerName"
            :value="item.customerID"
          ></el-option>
        </el-select>
      </el-form-item>

      <el-form-item
        prop="appname"
        label="应用名称"
        :label-width="formLabelWidth"
      >
        <el-select
          v-model="deliveryForm.appname"
          filterable
          placeholder="请选择"
          @change="this.changeApp"
        >
          <el-option
            v-for="item in appList"
            :key="item.productID"
            :label="item.name"
            :value="item.productID"
          ></el-option>
        </el-select>
      </el-form-item>

      <div>
        <!-- <el-form-item
          prop="version"
          label="版本选择:"
          :label-width="formLabelWidth"
        >
          <el-select
            @change="this.changeAppVersion"
            v-model="deliveryForm.version"
            placeholder="请选择"
          >
            <el-option
              v-for="item in versionList"
              :key="item.appVersion"
              :label="item.appVersion"
              :value="item.appVersion"
            ></el-option>
          </el-select>
        </el-form-item> -->
        <el-form-item
          prop="package"
          label="套餐选择:"
          :label-width="formLabelWidth"
        >
          <el-select
            v-model="deliveryForm.package"
            placeholder="请选择"
            @change="handleChangePackage"
          >
            <el-option
              v-for="item in curVersionPackageList"
              :key="item.packageID"
              :label="item.name"
              :value="item.packageID"
            ></el-option>
          </el-select>
        </el-form-item>
        <!-- 集群列表 -->
        <el-form-item label="交付集群" :label-width="formLabelWidth">
          <el-select
            v-model="deliveryForm.deliveryValue"
            filterable
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in RegionList"
              :key="item.regionID"
              :label="item.envName + '/' + item.regionAlias"
              :value="item.regionID"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="handleClose">取 消</el-button>
      <el-button type="primary" @click="submit" :loading="Loading">
        确 定
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
import { fetchCustomerList, fetchDeliveryList } from '@/api/customer';
import { fetchDeliveryRegionList } from '@/api/delivery';
import { getProductPackages } from '@/api/product';
export default {
  name: 'DialogDeliver',
  props: {
    dialogVisible: {
      type: Boolean,
      default: true
    },
    marketID: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      rules: {
        customer: [
          { required: true, message: '客户名称不能为空', trigger: 'blur' }
        ],
        appname: [
          { required: true, message: '应用名称不能为空', trigger: 'blur' }
        ],
        version: [{ required: true, message: '版本不能为空', trigger: 'blur' }],
        package: [{ required: true, message: '请选择套餐', trigger: 'blur' }]
      },
      deliveryForm: {
        customer: '',
        appname: '',
        version: '',
        package: '',
        deliveryValue: ''
      },
      Loading: false,
      formLabelWidth: '100px',
      captchaForm: {
        captcha_id: '',
        captcha_answer: '',
        price: 0,
        billCycle: '',
        name: ''
      },
      num: 1,
      totalPrice: 0,
      value: '',
      loading: false,
      versionList: [],
      curVersionPackageList: [],
      allPackageInfo: {},
      curPackageInfo: {},
      showDateZh: { month: '月', year: '年', quarter: '季度', week: '周' },
      appKeyID: '',
      appList: [],
      customerList: [],
      customerID: '',
      // 查询集群参数
      dlistQuery: {
        page: 1,
        pageSize: -1
      },
      // 集群列表
      RegionList: [],
      packageType: ''
    };
  },
  created() {
    this.getAppList();
    this.getCustomerList();
    // 加载集群列表
    this.handleDeliverRegionLis();
  },
  methods: {
    handleChangePackage(e) {
      const { packageType } = this.curVersionPackageList.find(
        (item) => item.packageID === e
      );
      this.packageType = packageType;
    },
    // 应用
    changeApp(appKeyID) {
      this.appKeyID = appKeyID;
      this.deliveryForm.package = '';
      this.getAppDetail();
    },
    changeCustomer(customerID) {

      this.customerID = customerID;
    },
    // 切换版本
    // changeAppVersion(version) {
    //   this.deliveryForm.version = version;
    //   this.isShowVerionList = false;
    //   this.curVersionPackageList =
    //     this.allPackageInfo[this.deliveryForm.version] || [];
    //   if (this.curVersionPackageList.length) {
    //     this.deliveryForm.package = this.curVersionPackageList[0].packageID;
    //     this.curPackageInfo = this.curVersionPackageList[0];
    //   } else {
    //     this.curPackageInfo = {};
    //   }
    // },
    // 应用列表
    getAppList() {
      const params = {
        marketID: this.marketID,
        page: 1,
        pageSize: 999
      };
      this.deliveryForm.appname && (params.query = this.deliveryForm.appname);
      fetchDeliveryList(params)
        .then((res) => {
          this.appList = res.products || [];
          this.appLoading = false;
        })
        .catch(() => {
          this.appLoading = false;
        });
    },
    //  集群列表
    async handleDeliverRegionLis() {
      this.dlistQuery.marketID = this.marketID;
      const listQuery = Object.assign({}, this.dlistQuery);
      const Result = await fetchDeliveryRegionList(listQuery);
      if (Result && Result.regions && Result.regions.length != 0) {
        this.RegionList = [].concat(Result.regions);
      }
    },
    submit() {
      this.$refs.Forms.validate((valid) => {
        if (valid) {
          const obj = {
            marketID: this.marketID,
            productID: this.appKeyID,
            comboID: this.deliveryForm.package,
            comboQuantity: this.num,
            packageType: this.packageType,
            customerID: this.customerID,
            regionID: this.deliveryForm.deliveryValue
          };
          if (
            this.appKeyID &&
            this.deliveryForm.package &&
            this.num &&
            this.customerID
          ) {
            this.Loading = true;
            this.$store
              .dispatch('ActiveDeliveryApp', obj)
              .then((res) => {
                this.handleClose();
                this.$message.success('操作成功，开始交付');
                this.Loading = false;
              })
              .catch(() => {
                this.Loading = false;
              });
          }
        }
      });
    },
    getCustomerList() {
      const obj = {
        page: 1,
        size: 10,
        marketID: this.marketID,
        query: this.deliveryForm.customer,
        simple: true
      };
      fetchCustomerList(obj).then((res) => {
        if (res && res.customers) {
          this.customerList = res.customers;
        } else {
          this.customerList = [];
        }
      });
    },
    handleClose() {
      this.$emit('handleClose');
      this.$refs.Forms.resetFields();
    },
    // 获取商品套餐列表
    getAppDetail() {
      if (!this.appKeyID) {
        return null;
      }
      getProductPackages({
        marketID: this.marketID,
        productID: this.appKeyID
      })
        .then((res) => {
          if (res && res.packages && res.packages.length > 0) {
            // 过滤掉业务套餐
            const temp_Arr = res.packages.reduce((pre, item) => {
              return item.packageType !== 'business' ? [...pre, item] : pre;
            }, []);
            this.curVersionPackageList = temp_Arr;
            if (temp_Arr.length > 0) {
              // 使用 $nextTick 确保选项列表渲染完成后再设置默认值
              this.$nextTick(() => {
                this.deliveryForm.package = temp_Arr[0].packageID;
                this.packageType = temp_Arr[0].packageType;
              });
            }
          } else {
            this.curVersionPackageList = [];
          }
        })
        .catch((err) => {
          this.detailLoading = false;
          this.$message.error(err.msg || '获取商品套餐失败');
        });
    }
  }
};
</script>

<style lang="scss">
.input-with-select .el-input-group__prepend {
  background: #f9f9f9;
}
.verification-item {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialog/Deliver/index.vue